import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { Loader2 } from 'lucide-react';

export default function AboutPage() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getContent('about').then(r => setContent(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>{content.title ? `${content.title} | Uretim Noktasi` : 'Hakkimizda | Uretim Noktasi'}</title>
        <meta name="description" content="Uretim Noktasi hakkinda bilgi. Turkiye genelinde endustriyel uretim hizmetleri icin guvenilir platform." />
      </Helmet>

      <section className="bg-slate-50 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-semibold" data-testid="about-title">{content.title || 'Hakkimizda'}</h1>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex items-center justify-center py-12"><Loader2 className="h-6 w-6 animate-spin" /></div>
          ) : content.content ? (
            <div className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: content.content }} data-testid="about-content" />
          ) : (
            <div className="text-center py-12 text-muted-foreground">
              <p>Icerik henuz eklenmemis.</p>
              <p className="text-sm mt-2">Admin Panel &gt; Icerik (CMS) &gt; "about" bolumunden duzenleyebilirsiniz.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
